var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "add-badge-icon-modal",
        title: "Add badge icon",
        "body-bg-variant": "white",
        "body-class": "bg-white"
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary" },
                  on: {
                    click: function($event) {
                      _vm.showAddBadgeIcon = false
                    }
                  }
                },
                [_vm._v("Close")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", disabled: _vm.picked == null },
                  on: {
                    click: function() {
                      _vm.pickIcon(_vm.picked)
                      _vm.showAddBadgeIcon = false
                    }
                  }
                },
                [_vm._v("Save")]
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.showAddBadgeIcon,
        callback: function($$v) {
          _vm.showAddBadgeIcon = $$v
        },
        expression: "showAddBadgeIcon"
      }
    },
    [
      _c(
        "div",
        { staticClass: "container-grid pl-3" },
        _vm._l(_vm.columns, function(column) {
          return _c(
            "div",
            { staticClass: "col-grid" },
            _vm._l(column, function(badgeIcon) {
              return _c("div", { staticClass: "item-container" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.picked,
                      expression: "picked"
                    }
                  ],
                  attrs: { type: "radio", id: "one" },
                  domProps: {
                    value: badgeIcon,
                    checked: _vm._q(_vm.picked, badgeIcon)
                  },
                  on: {
                    change: function($event) {
                      _vm.picked = badgeIcon
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  staticStyle: { "max-width": "100px" },
                  attrs: { src: badgeIcon.downloadUrl }
                })
              ])
            }),
            0
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }